export default function setupStickyObserver() {
	// Loosely based on https://gist.github.com/swarad07/fd5674fcc836aca1e092d7b568b5837c
	const stickyTrackers = new WeakMap();
	const stickyObserver = new IntersectionObserver( ( [ e ] ) => {
		const target = stickyTrackers.get( e.target );
		target?.classList.toggle( 'is-stickied', e.intersectionRatio < 1 );
	}, {
		threshold: [ 0, 1 ],
	} );

	document.querySelectorAll( '.js-sticky' ).forEach( target => {
		const tracker = document.createElement( 'div' );
		tracker.classList.add( 'js-sticky-tracker' );

		target.insertAdjacentElement( 'beforebegin', tracker );

		stickyTrackers.set( tracker, target );
		stickyObserver.observe( tracker );
	} );
}
